// extracted by css-extract-rspack-plugin
export default {"container":"loader-module__container___q9oSe","loader":"loader-module__loader___Rb8xJ","playSmall":"loader-module__playSmall___rNsEl","play":"loader-module__play___wTQko"};